import { Provider } from '@angular/core';
import { CX_COMPONENT } from '@core/models/atomics.model';
import { CxAuxiliaryLinksComponent } from '@b2b/components/cms/cx-auxiliary-links/cx-auxiliary-links.component';
import { CxFooterNavigationBarComponent } from '@b2b/components/cms/cx-footer-navigation-bar/cx-footer-navigation-bar.component';
import { CxLogoComponent } from '@b2b/components/cms/cx-logo/cx-logo.component';
import { CxMainNavigationBarComponent } from '@b2b/components/cms/cx-main-navigation-bar/cx-main-navigation-bar.component';
import { CxProfileLinksComponent } from '@b2b/components/cms/cx-profile-links/cx-profile-links.component';
import { CxTermLinkComponent } from '@b2b/components/cms/cx-term-link/cx-term-link.component';
import { provideComponent, provideSection } from '@b2b/components/cms/cx-abstract/cx-abstract.utils';
import { CxBannerCarouselComponent } from '@b2b/components/cms/cx-banner-carousel/cx-banner-carousel.component';
import { CxBannerGridComponent } from '@b2b/components/cms/cx-banner-grid/cx-banner-grid.component';
import { CxGridCategoriesComponent } from '@b2b/components/cms/cx-grid-categories/cx-grid-categories.component';
import { CxParagraphComponent } from '@b2b/components/cms/cx-paragraph/cx-paragraph.component';
import { CxProductCarouselComponent } from '@b2b/components/cms/cx-product-carousel/cx-product-carousel.component';

import { CxBreadcrumbSectionComponent } from '@b2b/components/cms/sections/cx-breadcrumb-section/cx-breadcrumb-section.component';
import { CxCartSectionComponent } from '@b2b/components/cms/sections/cx-cart-section/cx-cart-section.component';
import { CxCheckoutSectionComponent } from '@b2b/components/cms/sections/cx-checkout-section/cx-checkout-section.component';
import { CxFooterSectionComponent } from '@b2b/components/cms/sections/cx-footer-section/cx-footer-section.component';
import { CxHeaderSectionComponent } from '@b2b/components/cms/sections/cx-header-section/cx-header-section.component';
import { CxLoginSectionComponent } from '@b2b/components/cms/sections/cx-login-section/cx-login-section.component';
import { CxProductDetailsSectionComponent } from '@b2b/components/cms/sections/cx-product-details-section/cx-product-details-section.component';
import { CxProductListSectionComponent } from '@b2b/components/cms/sections/cx-product-list-section/cx-product-list-section.component';
import { CxTermsSectionComponent } from '@b2b/components/cms/sections/cx-terms-section/cx-terms-section.component';
import { CxOrderSectionComponent } from '@b2b/components/cms/sections/cx-order-section/cx-order-section.component';
import { CxEmptySectionComponent } from '@b2b/components/cms/sections/cx-empty-section/cx-empty-section.component';

const sectionsProviders: Provider[] = [
  provideSection({
    id: 'login-section',
    component: CxLoginSectionComponent,
  }),
  provideSection({
    id: 'header-section',
    component: CxHeaderSectionComponent,
  }),
  provideSection({
    id: 'footer-section',
    component: CxFooterSectionComponent,
  }),
  provideSection({
    id: 'breadcrumb-section',
    component: CxBreadcrumbSectionComponent,
  }),
  provideSection({
    id: 'product-list-section',
    component: CxProductListSectionComponent,
  }),
  provideSection({
    id: 'product-details-section',
    component: CxProductDetailsSectionComponent,
  }),
  provideSection({
    id: 'checkout-section',
    component: CxCheckoutSectionComponent,
  }),
  provideSection({
    id: 'cart-section',
    component: CxCartSectionComponent,
  }),
  provideSection({
    id: 'terms-section',
    component: CxTermsSectionComponent,
  }),
  provideSection({
    id: 'order-section',
    component: CxOrderSectionComponent,
  }),
  provideSection({
    id: 'empty-section',
    component: CxEmptySectionComponent,
  }),
];

const componentsProviders: Provider[] = [
  provideComponent({
    type: CX_COMPONENT.LOGO,
    component: CxLogoComponent,
  }),
  provideComponent({
    type: CX_COMPONENT.PROFILE_LINKS,
    component: CxProfileLinksComponent,
  }),
  provideComponent({
    type: CX_COMPONENT.MAIN_NAVIGATION_BAR,
    component: CxMainNavigationBarComponent,
  }),
  provideComponent({
    type: CX_COMPONENT.AUXILIARY_LINKS,
    component: CxAuxiliaryLinksComponent,
  }),
  provideComponent({
    type: CX_COMPONENT.BANNER_CAROUSEL,
    component: CxBannerCarouselComponent,
  }),
  provideComponent({
    type: CX_COMPONENT.BANNER_GRID,
    component: CxBannerGridComponent,
  }),
  provideComponent({
    type: CX_COMPONENT.GRID_CATEGORIES,
    component: CxGridCategoriesComponent,
  }),
  provideComponent({
    type: CX_COMPONENT.PRODUCT_CAROUSEL,
    component: CxProductCarouselComponent,
  }),
  provideComponent({
    type: CX_COMPONENT.FOOTER_NAVIGATION_BAR,
    component: CxFooterNavigationBarComponent,
  }),
  provideComponent({
    type: CX_COMPONENT.TERM_LINK,
    component: CxTermLinkComponent,
  }),
  provideComponent({
    type: CX_COMPONENT.PARAGRAPH,
    component: CxParagraphComponent,
  }),
];

export const cmsProviders: Provider[] = [...sectionsProviders, ...componentsProviders];
